export default {
  agencyBranch: {
    search: {
      placeholder: "Search by name, ID",
      notFound: {
        heading:
          "We couldn't find any agency / branch that match your refinements.",
        subHeading:
          "Try changing your criteria to find agency / branch you are after.",
      },
    },
    licenseNo: {
      title: "License No",
    },
    list: {
      heading: "Agency / Branch management",
      addBtn: "Create Agency/Branch",
      image: {
        error: "Invalid Image",
      },
      location: {
        label: "Location:",
      },
      reaId: {
        label: "ID:",
      },
      organizationLabel: {
        1: "Agency",
        2: "Branch",
      },
    },
    errorMessage: {
      required: "This is a required field!",
      duplicateReaId: {
        title: "Sorry, this REA ID already exists.",
        prompt:
          "Please contact your Squarefoot account manager to transfer this member to your team.",
      },
      notAllowEditReaIdWithListing: {
        title: "Error",
        prompt:
          "REAID can't be changed as the organization has existing listings. Please contact technical support.",
      },
      notAllowEditCurrentReaIdWithAllocation: {
        title: "Error",
        prompt:
          "REAID can't be changed as the organization has existing allocation inventory. Please contact technical support.",
      },
      notAllowEditForBoth: {
        title: "Error",
        prompt:
          "REAID can't be changed as the organization has existing allocation inventory / listings. Please contact technical support.",
      },
    },
    button: {
      cancel: "Cancel",
      create: "Create",
      saveChange: "Save Change",
    },
    contactDetails: {
      title: "Contact details",
      phone: {
        title: "Phone number",
      },
      email: {
        title: "Email",
      },
      website: {
        title: "Website",
        placeholder: "Enter website URL",
      },
    },
    previousId: {
      title: "Previous ID",
    },
    reaId: {
      title: "REA ID",
    },
    agencyList: {
      title: "What agency is this branch associated to ?",
      placeholder: "Please select",
    },
    location: {
      1: {
        title: "Location",
      },
      2: {
        title: "Branch location",
      },
    },
    assets: {
      title: "Brand assets",
      upload: {
        title: "Upload brand logo",
        btnText: "Add a brand logo",
        profileTitle: "Upload profile logo",
        btnProfileText: "Add a profile logo",
        resolutionError:
          "Image with resolution W x H (264px x 124px) will represent the profile best.",
      },
      color: {
        title: "Brand color",
        formatMessage: "The brand color value is not valid HEX",
        hexValue: "HEX value",
        placeholder: "#000000",
        prompt:
          "This colour will represent your brand, where applicable, across iproperty.com.my.",
      },
    },
    customizeBranding: {
      title: "Customize branding",
      tickDescription:
        "Enable brand name to be customized on the search results listing cards",
      input: {
        title: {
          "en-GB": "Brand name (English)*",
          "zh-HK": "Brand name (Traditional Chinese)*",
          "zh-CN": "Brand name (Simplified Chinese)*",
        },
        placeholder: {
          "en-GB": "Update your brand name",
          "zh-HK": "Update your brand name",
          "zh-CN": "Update your brand name",
        },
      },
    },
    organizationContract: {
      title: "Organisation Contract",
      tickDescription: "This agency/branch has a contract",
    },
    allocationManagement: {
      title: "Allocation Management",
      tickDescription: "Enable allocation management for this agency",
      note: "Please note: Once this function has been enable, you will need to contact the Customer Service team if you want to turn it off.",
    },
    organization: {
      backToList: "Back to agency/branch list",
      title: "Create an Agency or Branch",
      type: {
        title: "Organisation type",
      },
      name: {
        1: {
          title: {
            "en-GB": "Agency Name (English)",
            "zh-HK": "Agency Name (Traditional Chinese)",
            "zh-CN": "Agency Name (Simplified Chinese)",
          },
        },
        2: {
          title: {
            "en-GB": "Branch Name (English)",
            "zh-HK": "Branch Name (Traditional Chinese)",
            "zh-CN": "Branch Name (Simplified Chinese)",
          },
        },
      },
      address: {
        title: {
          "en-GB": "Address (English)",
          "zh-HK": "Address (Traditional Chinese)",
          "zh-CN": "Address (Simplified Chinese)",
        },
        placeholder: {
          "en-GB": "eg. 123 Wan Chai Road",
          "zh-HK": "eg. 123 Wan Chai Road",
          "zh-CN": "eg. 123 Wan Chai Road",
          "ms-MY": "eg. Jalan Kuching",
        },
      },
    },
  },
};
